<div class="gh-distance" *ngIf="!ghResulted; else ghWinMarketResult">
    <span *ngIf="race.racingpost.distance; else distance"> {{ race.racingpost.distance }}{{ sitecore.horseRacing.raceResulted.Meters }} | </span>
    <ng-template #distance>
        <span *ngIf="race.addons.distance"> {{ race.addons.distance }} | </span>
    </ng-template>
</div>
<ng-template #ghWinMarketResult>
    <span class="gh-win-market-resulted" *ngIf="race.racingpost.distance; else distance">
        {{ race.racingpost.distance }}{{ sitecore.horseRacing.raceResulted.Meters }}
    </span>
    <ng-template #distance>
        <span class="gh-win-market-resulted" *ngIf="race.addons.distance"> {{ race.addons.distance }}</span>
    </ng-template>
</ng-template>
